import { Component, OnInit } from '@angular/core';
import {Routes, RouterModule , Router,ActivatedRoute, Params} from '@angular/router';
import { LeadService } from '../lead.service';
import { Observable } from 'rxjs';
import { Lead } from '../lead';
import { FormControl, FormBuilder, FormArray,FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { DesignerService } from '../../designer/designer.service';
declare var $:any;

@Component({
  selector: 'app-detailed-info',
  templateUrl: './detailed-info.component.html',
  styleUrls: ['./detailed-info.component.css'],
  providers: [LeadService, LoaderService, DesignerService]
})
export class DetailedInfoComponent implements OnInit {
  lead_id:any;
  role:any;
  lead_details:any;
  selectedSet:any = 'csq';
  customerStatusUpdateForm : FormGroup;
  LeadquestionnaireForm: FormGroup;
  designerBookingForm1 : FormGroup;
  designerBookingForm2:FormGroup;
  leadquestionnaire : FormGroup;
  addleadquestionnaire : FormGroup;
  customerDetails:any;
  projectDetailsForModal;

  leadIdForModal;
  bookingFormDetails:any = {};
  basefile;
  attachment_file;
  successalert;
  successMessage;
  erroralert;
  errorMessage;
  designerId;
  lead_questionnaire;
  project_id;

  accommodation_type = ['Studio Apartment','1RK','1BHK','1.5BHK','2BHK','2.5BHK','3BHK',
    '3.5BHK','4BHK','4.5BHK','5BHK','Villa','Bungalow','Office Space'];
  callbacktime = ['10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM','1:00 PM',
                '1:30 PM','2:00 PM','2:30 PM','3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM',
                '5:30 PM','6:00 PM','6:30 PM','7:00 PM','7:30 PM','8:00 PM','8:30 PM','9:00 PM','9:30 PM',
                '10:00 PM','10:30 PM','11:00 PM'];
  scopeOfwork = ['Modular Kitchen','Loose Furniture','Full Home Interiors (Design)','Full Home Interiors (Design & Fullfilment)','Partial Home Interiors (e.g. MKW + Living Room)'];

  lead_status;

  constructor(
    public activatedRoute: ActivatedRoute,
    public leadService : LeadService,
    public loaderService : LoaderService,
    public designerService : DesignerService,
    private formBuilder: FormBuilder,
    private route:ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
        this.lead_id = params['leadId'];
      });
    this.route.queryParams.subscribe(params => {
      this.lead_status = params['lead_status'];
    });
    this.role = localStorage.getItem('user');

    this.fetchBasicDetails();
    this.updateFormGroup();
  }

  fetchBasicDetails(){
    this.leadService.getLeadLogs(this.lead_id).subscribe(
      res => {
        this.lead_details = res['lead'];
        // this.updateFormGroup();
        this.getCitiesForQuestionnaire();
        // this.getUserQuestionnaireDetails(this.lead_details.id)
        this.getDesignerBookingForm(this.lead_details.project_details.id)
      },
      err => {
        console.log(err);
      }
    );
  }

  isProjectInWip():boolean {
    var wip_array = ["wip", "pre_10_percent", "10_50_percent", "50_percent", "installation", "on_hold", "inactive"]
    if(this.lead_details.project_details && this.lead_details.project_details.status && wip_array.includes(this.lead_details.project_details.status)){
      return true
    }
    else{
      return false
    }
  }

  updateFormGroup(){
    this.LeadquestionnaireForm = this.formBuilder.group({
      customer_name : new FormControl("",Validators.required),
      phone : new FormControl(""),
      project_name: new FormControl(""),
      city : new FormControl("",Validators.required),
      location: new FormControl("",Validators.required),
      project_type :new FormControl("",Validators.required),
      accomodation_type: new FormControl("",Validators.required),
      // scope_of_work : new FormArray([],Validators.required),
      scope_of_work : new FormControl("",Validators.required),
      possession_status :new FormControl("",Validators.required),
      have_homeloan: new FormControl("",Validators.required),
      call_back_day: new FormControl("",Validators.required),
      call_back_time: new FormControl(""),
      lead_generator: new FormControl(""),
      home_type: new FormControl("",Validators.required),
      lead_source:new FormControl(""),
      have_floorplan: new FormControl(""),
      remarks_of_sow: new FormControl(),
      possession_status_date:new FormControl(),
      lead_floorplan:new FormControl(""),
      society:new FormControl("",Validators.required),
      budget_value:new FormControl("",Validators.required),
      home_value: new FormControl("",Validators.required),
      additional_comments :new FormControl(""),
      ownerable_type : new FormControl('Lead'),
      user_id : new FormControl(localStorage.getItem('userId')),
      ownerable_id : new FormControl(),
      cm_comments: new FormControl(),
      designer_comments:new FormControl()
    });

    this.designerBookingForm1 = this.formBuilder.group({
      customer_name : new FormControl(),
      customer_age : new FormControl(),
      profession : new FormControl(),
      family_profession : new FormControl(),
      age_house : new FormControl(),
      lifestyle : new FormControl(),
      house_positive_features : new FormControl(),
      house_negative_features : new FormControl(),
      inspiration : new FormControl(),
      color_tones : new FormControl(),
      theme : new FormControl(),
      functionality : new FormControl(),
      false_ceiling : new FormControl(),
      electrical_points : new FormControl(),
      special_needs : new FormControl(),
      vastu_shastra : new FormControl(),
      all_at_once : new FormControl(),
      budget_range : new FormControl(),
      design_style_tastes : new FormControl(),
      storage_space : new FormControl(),
      mood : new FormControl(),
      enhancements : new FormControl(),
      discuss_in_person : new FormControl(),
      mk_age:new FormControl(),
      mk_gut_kitchen :new FormControl(),
      mk_same_layout :new FormControl(),
      mk_improvements :new FormControl(),
      mk_special_requirements :new FormControl(),
      mk_cooking_details :new FormControl(),
      mk_appliances :new FormControl(),
      mk_family_eating_area :new FormControl(),
      mk_guest_frequence :new FormControl(),
      mk_storage_patterns :new FormControl(),
      mk_cabinet_finishing :new FormControl(),
      mk_countertop_materials:new FormControl(),
      mk_mood:new FormControl(),
      mk_lifestyle : new FormControl()
    });
    if(this.role!='designer'){
      this.LeadquestionnaireForm.controls['phone'].setValidators([Validators.required]);
    }
  }
  closeModal(){
    this.lead_questionnaire =undefined;
    this.city_others = undefined;
    }

  getSet(setType){
    this.selectedSet = setType;
    if(setType == "csq"){
      this.getUserQuestionnaireDetails(this.lead_details.id)
    }
    // else if(setType == "bf_1" || setType == "bf_2"){
    //   console.log("ani");
    //   this.getDesignerBookingForm(this.lead_details.project_details.id)
    // }
  }

  fpQuestionnaireSelected(val){
      if(val == 'yes'){
        document.getElementById('floorplanQuestionnaire').style.display = 'block';
      } else {
        document.getElementById('floorplanQuestionnaire').style.display = 'none';
        this.floorplan_attachment_file = undefined;
        this.questionnaire_floorplan_basefile = undefined;
      }
  }



  designerBookingForm1Submit(data,formName){
    this.loaderService.display(true);
    data['customer_name'] = this.lead_details.user_reference.name;
    data['project_id'] = this.lead_details.project_details.id;
    data['inspiration_image'] = this.basefile;
    this.designerService.SubmitDesignerBookingForm(data,data['project_id']).subscribe(
      res => {
        this.designerBookingForm1.reset();
        this.bookingFormDetails = res;
        this.basefile = undefined;
        this.attachment_file = undefined;
        this.setBookingFormControlsValue(this.bookingFormDetails.designer_booking_form);
        this.loaderService.display(false);
        this.successalert = true;
        this.successMessage = 'Form submitted successfully!';
        $('#leadDetailsModal').scrollTop(0);
        setTimeout(function() {
             this.successalert = false;
        }.bind(this), 5000);
      },
      err => {
        console.log(err);
        this.loaderService.display(false);
        this.erroralert = true;
        this.errorMessage = JSON.parse(err['_body']).message;
        $('#leadDetailsModal').scrollTop(0);
        setTimeout(function() {
            this.erroralert = false;
        }.bind(this), 5000);
      }
    );
  }

  setBookingFormControlsValue(obj){
    this.designerBookingForm1.controls['customer_name'].setValue(obj.general.customer_name);
    this.designerBookingForm1.controls['customer_age'].setValue(obj.general.customer_age);
    this.designerBookingForm1.controls['age_house'].setValue(obj.general.age_house);
    this.designerBookingForm1.controls['all_at_once'].setValue(obj.general.all_at_once);
    this.designerBookingForm1.controls['budget_range'].setValue(obj.general.budget_range);
    this.designerBookingForm1.controls['color_tones'].setValue(obj.general.color_tones);
    this.designerBookingForm1.controls['design_style_tastes'].setValue(obj.general.design_style_tastes);
    this.designerBookingForm1.controls['discuss_in_person'].setValue(obj.general.discuss_in_person);
    this.designerBookingForm1.controls['electrical_points'].setValue(obj.general.electrical_points);
    this.designerBookingForm1.controls['enhancements'].setValue(obj.general.enhancements);
    this.designerBookingForm1.controls['false_ceiling'].setValue(obj.general.false_ceiling);
    this.designerBookingForm1.controls['family_profession'].setValue(obj.general.family_profession);
    this.designerBookingForm1.controls['functionality'].setValue(obj.general.functionality);
    this.designerBookingForm1.controls['house_negative_features'].setValue(obj.general.house_negative_features);
    this.designerBookingForm1.controls['house_positive_features'].setValue(obj.general.house_positive_features);
    this.designerBookingForm1.controls['inspiration'].setValue(obj.general.inspiration);
    this.designerBookingForm1.controls['lifestyle'].setValue(obj.general.lifestyle);
    this.designerBookingForm1.controls['mood'].setValue(obj.general.mood);
    this.designerBookingForm1.controls['profession'].setValue(obj.general.profession);
    this.designerBookingForm1.controls['special_needs'].setValue(obj.general.special_needs);
    this.designerBookingForm1.controls['storage_space'].setValue(obj.general.storage_space);
    this.designerBookingForm1.controls['theme'].setValue(obj.general.theme);
    this.designerBookingForm1.controls['vastu_shastra'].setValue(obj.general.vastu_shastra);
    this.designerBookingForm1.controls['mk_age'].setValue(obj.modular_kitchen.mk_age);
    this.designerBookingForm1.controls['mk_appliances'].setValue(obj.modular_kitchen.mk_appliances);
    this.designerBookingForm1.controls['mk_cabinet_finishing'].setValue(obj.modular_kitchen.mk_cabinet_finishing);
    this.designerBookingForm1.controls['mk_cooking_details'].setValue(obj.modular_kitchen.mk_cooking_details);
    this.designerBookingForm1.controls['mk_countertop_materials'].setValue(obj.modular_kitchen.mk_countertop_materials);
    this.designerBookingForm1.controls['mk_family_eating_area'].setValue(obj.modular_kitchen.mk_family_eating_area);
    this.designerBookingForm1.controls['mk_guest_frequence'].setValue(obj.modular_kitchen.mk_guest_frequence);
    this.designerBookingForm1.controls['mk_gut_kitchen'].setValue(obj.modular_kitchen.mk_gut_kitchen);
    this.designerBookingForm1.controls['mk_improvements'].setValue(obj.modular_kitchen.mk_improvements);
    this.designerBookingForm1.controls['mk_lifestyle'].setValue(obj.modular_kitchen.mk_lifestyle);
    this.designerBookingForm1.controls['mk_mood'].setValue(obj.modular_kitchen.mk_mood);
    this.designerBookingForm1.controls['mk_same_layout'].setValue(obj.modular_kitchen.mk_same_layout);
     this.designerBookingForm1.controls['mk_special_requirements'].setValue(obj.modular_kitchen.mk_special_requirements);
    this.designerBookingForm1.controls['mk_storage_patterns'].setValue(obj.modular_kitchen.mk_storage_patterns);

    if(obj.general.customer_age==null && obj.general.age_house == null && obj.general.all_at_once==null &&
      obj.general.budget_range == null && obj.general.color_tones == null && obj.general.design_style_tastes==null &&
      obj.general.discuss_in_person == null && obj.general.electrical_points== null && obj.general.enhancements == null &&
      obj.general.false_ceiling == null && obj.general.family_profession == null && obj.general.functionality==null &&
      obj.general.house_negative_features == null && obj.general.house_positive_features == null && obj.general.inspiration ==null &&
      obj.general.lifestyle == null && obj.general.mood==null && obj.general.profession == null && obj.general.special_needs==null &&
      obj.general.storage_space==null && obj.general.theme==null && obj.general.vastu_shastra ==null) {
        document.getElementById('designerBookingForm1Button').innerHTML = 'SUBMIT';
    } else {
        document.getElementById('designerBookingForm1Button').innerHTML = 'UPDATE';
    }

    if(obj.modular_kitchen.mk_age==null && obj.modular_kitchen.mk_appliances==null && obj.modular_kitchen.mk_cabinet_finishing == null &&
      obj.modular_kitchen.mk_cooking_details==null && obj.modular_kitchen.mk_countertop_materials==null &&
      obj.modular_kitchen.mk_family_eating_area==null && obj.modular_kitchen.mk_guest_frequence==null &&
      obj.modular_kitchen.mk_gut_kitchen==null && obj.modular_kitchen.mk_improvements==null &&
      obj.modular_kitchen.mk_lifestyle==null && obj.modular_kitchen.mk_mood==null &&
      obj.modular_kitchen.mk_same_layout==null && obj.modular_kitchen.mk_special_requirements==null &&
      obj.modular_kitchen.mk_storage_patterns==null && obj.general.customer_age==null && obj.general.profession==null &&
      obj.general.family_profession == null) {
        document.getElementById('designerBookingForm2Button').innerHTML = 'SUBMIT';
    } else {
        document.getElementById('designerBookingForm2Button').innerHTML = 'UPDATE';
    }

  }
  estimatedPossessionTime = ['Jan-18','Feb-18','Mar-18','Apr-18','May-18',
    'Jun-18','Jul-18','Aug-18','Sep-18','Oct-18','Nov-18','Dec-18'];
  onCheckChange(event,htmlElemName) {
    // var formArray: FormArray;
    // var addLeadFormArray : FormArray;
    // if(htmlElemName== 'scope_of_work') {
    //   formArray = this.leadquestionnaire.get('scope_of_work') as FormArray;
    //   addLeadFormArray =  this.addleadquestionnaire.get('scope_of_work') as FormArray;
    // }
    // /* Selected */
    // if(event.target.checked){
    //   // Add a new control in the arrayForm
    //   formArray.push(new FormControl(event.target.value));
    //   addLeadFormArray.push(new FormControl(event.target.value));
    // }
    // /* unselected */
    // else{
    //   // find the unselected element
    //   let i: number = 0;
    //   var j:number = 0;

    //   formArray.controls.forEach((ctrl: FormControl) => {
    //     if(ctrl.value == event.target.value) {
    //       // Remove the unselected element from the arrayForm
    //       formArray.removeAt(i);
    //       return;
    //     }

    //     i++;
    //   });
    //   addLeadFormArray.controls.forEach((ctr: FormControl) => {
    //     if(ctr.value == event.target.value) {
    //       // Remove the unselected element from the arrayForm
    //       addLeadFormArray.removeAt(j);
    //       return;
    //     }

    //     j++;
    //   });
    //   if(event.target.value =='Remarks'){
    //     this.leadquestionnaire.controls['remarks_of_sow'].setValue("");
    //     this.addleadquestionnaire.controls['remarks_of_sow'].setValue("");
    //   }
    // }
    var updateFormArray : FormArray;
      if(htmlElemName== 'scope_of_work') {
        updateFormArray = this.LeadquestionnaireForm.get('scope_of_work') as FormArray;
      }
      /* Selected */
      if(event.target.checked){
        updateFormArray.push(new FormControl(event.target.value));
      }
      /* unselected */
      else{
        var j:number = 0;
        updateFormArray.controls.forEach((ctr: FormControl) => {
          if(ctr.value == event.target.value) {
            // Remove the unselected element from the arrayForm
            updateFormArray.removeAt(j);
            return;
          }

          j++;
        });
        if(event.target.value =='Remarks'){
          this.LeadquestionnaireForm.controls['remarks_of_sow'].setValue("");
        }
      }
  }
  questionnaire_floorplan_basefile: any;
  floorplan_attachment_file:any;
  onQuestionnaireFloorplanChange(event){
    this.questionnaire_floorplan_basefile = undefined;
    this.floorplan_attachment_file = event.srcElement.files[0];
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(this.floorplan_attachment_file.name)[1];
    var fileReader = new FileReader();
    var base64;
    if(ext == 'jpg' || ext == 'jpeg' || ext=='png' || ext=='gif' || ext=='svg') {
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target;
        this.questionnaire_floorplan_basefile = base64.result;
      };
    } else {
      document.getElementById('extErrorMsg').classList.remove('d-none');
    }
    fileReader.readAsDataURL(this.floorplan_attachment_file);
  }



  getDesignerBookingForm(projectId){
    this.designerService.getDesignerBookingForm(projectId).subscribe(
      res => {
        this.bookingFormDetails = res;
        this.setBookingFormControlsValue(this.bookingFormDetails.designer_booking_form);
      },
      err => {
        console.log(err);
      }
    );
  }
  city_others;
  possesionStatusSelected(val,formName) {
      if(val == 'Awaiting Possession' && formName=='updateQuestionnaire') {
        if(document.getElementById('possesiondateupdate')!=null){
          document.getElementById('possesiondateupdate').style.display = 'block';
          this.LeadquestionnaireForm.controls['possession_status_date'].setValidators([Validators.required]);
          this.LeadquestionnaireForm.controls['possession_status_date'].updateValueAndValidity();
        }
      }

      if(val =='Possession Taken' && formName=='updateQuestionnaire') {
        if(document.getElementById('possesiondateupdate')!=null){
          document.getElementById('possesiondateupdate').style.display='none';
        }
        this.LeadquestionnaireForm.controls['possession_status_date'].setValue(undefined);
        this.LeadquestionnaireForm.controls['possession_status_date'].clearValidators();
          this.LeadquestionnaireForm.controls['possession_status_date'].updateValueAndValidity();
      }
  }
  updateRecordNotesQuestionnaire(leadId,data){
      if(this.LeadquestionnaireForm.controls['city'].value == 'Other'){
          this.LeadquestionnaireForm.controls['city'].setValue(this.city_others);
          data['city']=this.city_others;
      }
      this.loaderService.display(true);
      this.LeadquestionnaireForm.controls['ownerable_id'].setValue(this.lead_details.id);
      // if(this.LeadquestionnaireForm !=null){
      //   var noteRecordId = this.lead_questionnaire.id;
      //   console.log(noteRecordId);
      //   data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
      //   this.leadService.updateRecordNotesQuestionnaire(this.lead_id,data,noteRecordId).subscribe(
      //       res => {
      //         this.successalert = true;
      //         this.successMessage = "Updated successfully !!";
      //         $('#questionnaireModal').modal('hide');
      //         // this.LeadquestionnaireForm.reset();
      //         this.questionnaire_floorplan_basefile = undefined;
      //         this.floorplan_attachment_file = undefined;
      //         this.city_others=undefined;
      //          setTimeout(function() {
      //                this.successalert = false;
      //           }.bind(this), 10000);
      //          alert("updated successfully!");
      //        // this.getUserQuestionnaireDetails(this.leadIDForModal);
      //         //Object.keys(res).map((key)=>{ this.leadRecordNotes= res[key];});
      //         this.loaderService.display(false);
      //       },
      //       err => {
      //         console.log(err);
      //         this.erroralert = true;
      //         this.errorMessage = JSON.parse(err['_body']).message;
      //         setTimeout(function() {
      //                this.erroralert = false;
      //           }.bind(this), 10000);
      //         this.loaderService.display(false);
      //       }
      //     );
      // }

      if(this.lead_questionnaire !=null && this.lead_questionnaire.length!=0){
        var noteRecordId = this.lead_questionnaire.id || this.lead_questionnaire[0].id;
        data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
        data['scope_of_work']=[data['scope_of_work']];
        this.leadService.updateRecordNotesQuestionnaire(this.lead_details.id,data,noteRecordId).subscribe(
            res => {
              this.successalert = true;
              this.successMessage = "Updated successfully !!";
              // $('#questionnaireModal').modal('hide');
              this.LeadquestionnaireForm.reset();
              this.questionnaire_floorplan_basefile = undefined;
              this.floorplan_attachment_file = undefined;
              this.city_others=undefined;
               setTimeout(function() {
                     this.successalert = false;
                }.bind(this), 10000);
             this.getUserQuestionnaireDetails(this.lead_details.id);
              //Object.keys(res).map((key)=>{ this.leadRecordNotes= res[key];});
              alert("Updated successfully");
              this.loaderService.display(false);
            },
            err => {
              console.log(err);
              this.erroralert = true;
              this.errorMessage = JSON.parse(err['_body']).message;
              setTimeout(function() {
                     this.erroralert = false;
                }.bind(this), 10000);
              this.loaderService.display(false);
            }
          );
      }

      if(this.lead_questionnaire == null || (this.lead_questionnaire !=null && this.lead_questionnaire.length==0)){
        data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
        data['scope_of_work']=[data['scope_of_work']];
        this.leadService.postRecordNotesQuestionnaire(this.lead_details.id,data).subscribe(
            res => {
                //Object.keys(res).map((key)=>{ this.userQuestionnaireDetails= res[key];});
                this.floorplan_attachment_file = undefined;
                this.loaderService.display(false);
                this.LeadquestionnaireForm.reset();
                // $('#questionnaireModal').modal('hide');
                this.getUserQuestionnaireDetails(this.lead_details.id);
                //this.setQuestionnaireDetails(this.userQuestionnaireDetails);

                this.successalert = true;
                this.successMessage = "Form submitted successfully!";
                setTimeout(function() {
                  this.successalert = false;
                }.bind(this), 10000);
            },
            err => {
              console.log(err);
               this.erroralert = true;
              this.errorMessage = JSON.parse(err['_body']).message;
              this.loaderService.display(false);
              setTimeout(function() {
                  this.erroralert = false;
                }.bind(this), 10000);
            }
          );
      }



  }

  getCustomerDetails(customer_id){
    this.designerService.getCustomerDetails(customer_id,this.designerId).subscribe(
      res => {
        Object.keys(res).map((key)=>{ res= res[key];});
        this.customerDetails = res;
      },
      err => {
        console.log(err);
      }
    );
  }
  onchangeCity1(city){
    if(city=='Other'){
      document.getElementById('cityOthersInput1').classList.remove('d-none');
    } else{
      document.getElementById('cityOthersInput1').classList.add('d-none');
    }
  }
  onchangeCity2(city){
    if(city=='Other'){
      document.getElementById('cityOthersInput2').classList.remove('d-none');
    } else{
      document.getElementById('cityOthersInput2').classList.add('d-none');
    }
  }

  getUserQuestionnaireDetails(customerId){
    this.loaderService.display(true);
    this.leadService.getRecordNotesQuestionnaire(customerId).subscribe(
      res=>{
        Object.keys(res).map((key)=>{ res= res[key];});
        this.lead_questionnaire = res;
        // if(res!=null && res.length>0){
        //   this.lead_questionnaire = res[0];
        //   this.setCsQuestionnaire();
        // }
         if(this.lead_questionnaire!= null && this.lead_questionnaire.length != 0){
            this.setCsQuestionnaire(this.lead_questionnaire[0]);
          } else {
            this.LeadquestionnaireForm.reset();
            this.LeadquestionnaireForm.controls['customer_name'].setValue(this.lead_details.name);
            this.LeadquestionnaireForm.controls['phone'].setValue(this.lead_details.contact);
            // this.LeadquestionnaireForm.controls['society'].setValue("");
            this.LeadquestionnaireForm.controls['project_name'].setValue("");
            // this.LeadquestionnaireForm.controls['home_type'].setValue("");
            this.LeadquestionnaireForm.controls['city'].setValue("");
            this.LeadquestionnaireForm.controls['location'].setValue("");
            this.LeadquestionnaireForm.controls['project_type'].setValue(""),
            this.LeadquestionnaireForm.controls['home_type'].setValue("");
            this.LeadquestionnaireForm.controls['accomodation_type'].setValue("");
            this.LeadquestionnaireForm.controls['scope_of_work'].setValue("");
            this.LeadquestionnaireForm.controls['budget_value'].setValue("");
            this.LeadquestionnaireForm.controls['home_value'].setValue("");
            this.LeadquestionnaireForm.controls['possession_status'].setValue("");
            this.LeadquestionnaireForm.controls['society'].setValue("");

            // remarks_of_sow: new FormControl(),
            this.LeadquestionnaireForm.controls['possession_status_date'].setValue("");
            this.LeadquestionnaireForm.controls['have_homeloan'].setValue("");
            this.LeadquestionnaireForm.controls['call_back_day'].setValue("");
            this.LeadquestionnaireForm.controls['call_back_time'].setValue("");
            this.LeadquestionnaireForm.controls['have_floorplan'].setValue("");

            // this.updateLeadquestionnaireForm.controls['lead_generator'].setValue("");
            // this.updateLeadquestionnaireForm.controls['lead_source'].setValue("");
            this.LeadquestionnaireForm.controls['lead_floorplan'].setValue("");
            this.LeadquestionnaireForm.controls['additional_comments'].setValue("");
            this.LeadquestionnaireForm.controls['cm_comments'].setValue("");
            this.LeadquestionnaireForm.controls['designer_comments'].setValue("");
            this.LeadquestionnaireForm.controls['ownerable_type'].setValue('Lead');
            this.LeadquestionnaireForm.controls['user_id'].setValue(localStorage.getItem('userId'));
            this.LeadquestionnaireForm.controls['ownerable_id'].setValue("");
            document.getElementById('floorplanQuestionnaire').style.display = 'none';
            document.getElementById('possesiondateupdate').style.display='none';
            // document.getElementById('floorplanQuestionnaire').style.display = 'none';
          }

        this.loaderService.display(false);
      },
      err=>{
        this.loaderService.display(false);
        console.log(err);
      }
     );
  }

  setCsQuestionnaire(note_records){
    this.LeadquestionnaireForm.controls['customer_name'].setValue(note_records.customer_name);
    this.LeadquestionnaireForm.controls['phone'].setValue(note_records.phone);
    this.LeadquestionnaireForm.controls['project_name'].setValue(note_records.project_name);
    // this.LeadquestionnaireForm.controls['city'].setValue(note_records.city);
    this.LeadquestionnaireForm.controls['location'].setValue(note_records.location);
    this.LeadquestionnaireForm.controls['society'].setValue(note_records.society);
    this.LeadquestionnaireForm.controls['project_type'].setValue(note_records.project_type);
    this.LeadquestionnaireForm.controls['home_type'].setValue(note_records.home_type);
    this.LeadquestionnaireForm.controls['accomodation_type'].setValue(note_records.accomodation_type);
    if(note_records.scope_of_work != null) {
      if(note_records.scope_of_work.length>0){
        this.LeadquestionnaireForm.controls['scope_of_work'].setValue(note_records.scope_of_work[0]);
      }
      // this.LeadquestionnaireForm.controls['scope_of_work']['controls']=[];
      // for(var k=0;k<note_records.scope_of_work.length;k++){
      //   this.LeadquestionnaireForm.controls['scope_of_work']['controls'].push(new FormControl(note_records.scope_of_work[k]));
      // }
      // this.LeadquestionnaireForm.controls['scope_of_work'].setValue(note_records.scope_of_work);
    }

    this.LeadquestionnaireForm.controls['possession_status'].setValue(note_records.possession_status);
    this.LeadquestionnaireForm.controls['possession_status_date'].setValue(note_records.possession_status_date);
    this.LeadquestionnaireForm.controls['have_homeloan'].setValue(note_records.have_homeloan);
    this.LeadquestionnaireForm.controls['home_value'].setValue(note_records.home_value);
    this.LeadquestionnaireForm.controls['budget_value'].setValue(note_records.budget_value);
    this.LeadquestionnaireForm.controls['call_back_day'].setValue(note_records.call_back_day);
    this.LeadquestionnaireForm.controls['lead_source'].setValue(note_records.lead_source);

    this.LeadquestionnaireForm.controls['lead_generator'].setValue(note_records.lead_generator);
    this.LeadquestionnaireForm.controls['possession_status_date'].setValue(note_records.possession_status_date);
    this.LeadquestionnaireForm.controls['call_back_time'].setValue(note_records.call_back_time);
    this.LeadquestionnaireForm.controls['have_floorplan'].setValue(note_records.have_floorplan);
    this.LeadquestionnaireForm.controls['lead_floorplan'].setValue(note_records.lead_floorplan);
    this.LeadquestionnaireForm.controls['additional_comments'].setValue(note_records.additional_comments);
    this.LeadquestionnaireForm.controls['cm_comments'].setValue(note_records.cm_comments);
    this.LeadquestionnaireForm.controls['designer_comments'].setValue(note_records.designer_comments);
    var elem = this.citiesForQuestionnaire.find(function(e) {
        return e.name == (note_records.city.toLowerCase());
    });
    if(elem !=undefined){
      this.LeadquestionnaireForm.controls['city'].setValue(note_records.city.toLowerCase());
    }
    else {
      this.LeadquestionnaireForm.controls['city'].setValue('Other');
      this.city_others = note_records.city;
      document.getElementById('cityOthersInput1').classList.remove('d-none');
    }
    if(note_records.have_floorplan == 'Yes'){
      document.getElementById('floorplanQuestionnaire').style.display = 'block';
    } if(note_records.have_floorplan == 'No'){
      document.getElementById('floorplanQuestionnaire').style.display = 'none';
    }

    if(note_records.possession_status=='Awaiting Possession'){
        document.getElementById('possesiondateupdate').style.display = 'block';
      }
      if(note_records.possession_status=='Possession Taken'){
        document.getElementById('possesiondateupdate').style.display = 'none';
      }

  }
  callResponse: any;
  callToLead(leadId){
    this.loaderService.display(true);
    this.designerService.callToLead(localStorage.getItem('userId'), leadId).subscribe(
        res => {
           this.loaderService.display(false);
          if(res.inhouse_call.call_response.code == '403'){
            this.erroralert = true;
            this.errorMessage = JSON.parse(res.message.body).RestException.Message;
            setTimeout(function() {
                 this.erroralert = false;
            }.bind(this), 10000);
            //JSON.parse(temp1.body).RestException.Message
          } else {
            this.callResponse =  JSON.parse(res.inhouse_call.call_response.body);
            this.successalert = true;
            this.successMessage = 'Calling from - '+this.callResponse.Call.From;
            setTimeout(function() {
                 this.successalert = false;
            }.bind(this), 10000);
          }
        },
        err => {
          this.loaderService.display(false);
          console.log(err);
        }
     );
  }

  citiesForQuestionnaire;
  getCitiesForQuestionnaire(){
    this.loaderService.display(true);
    this.leadService.getCitiesForQuestionnaire().subscribe(
      res=>{
        this.citiesForQuestionnaire = res.cities;
        this.getUserQuestionnaireDetails(this.lead_details.id)
        this.loaderService.display(false);
      },
      err =>{
        console.log(err);
        this.loaderService.display(false);
      }
    );
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/detailed-info/detailed-info.component.ts